<script>
export default {
  name: 'SocialTelegram',
  props: {
    url: String,
  },
};
</script>

<template>
  <a :href="url" target="_blank">
    <svg class="ico"><use xlink:href="#ico-telegram"></use></svg>
  </a>
</template>

<style scoped lang="scss"></style>
